import {LayerBase} from "./LayerBase";
import {LayerPluginInterface} from "../LayerInterface";
import BaseLayer from "ol/layer/Base";
import TileLayer from "ol/layer/Tile";
import {TileWMS} from "ol/source";

export class Tilewms extends LayerBase implements LayerPluginInterface {
  /**
   * Build the vector based layer.
   */
  buildLayer(): BaseLayer | null {

    let url = this.openlayers.mapConfig.data.layers[this.layerId].data.url;
    let source_params = this.openlayers.mapConfig.data.layers[this.layerId].data.params;
    let layer_params = this.openlayers.mapConfig.data.layers[this.layerId].params;
    const layer = new TileLayer({
      zIndex: - this.weight,
      source: new TileWMS({
        url: url,
        params: source_params
      })
    });
    layer.setProperties(layer_params);
    return layer;
  }
}

